export default "__VITE_ASSET__JzMrb0m7__"